import React , {useState,useEffect} from 'react'
import {Table,Button} from "react-bootstrap"
import {useHistory} from "react-router-dom"
import "./total.css"
import Header from "./Header"
import {Grid} from "@material-ui/core"
import GreenLL from "./GreenLL"
import OrangeLL from "./OrangeLL"
import RedLL from "./RedLL"
import GreenUL from "./GreenUL"
import OrangeUL from "./OrangeUL"
import RedUL from "./RedUL"

import { Icon, InlineIcon } from '@iconify/react';
import homeIcon from '@iconify-icons/fa-solid/home';


function CalculateTotal() {
    let history = useHistory();

    //to store in table
    var weight = localStorage.getItem("current weight")
    var dext = localStorage.getItem("dextrose")
    var prot = localStorage.getItem("protein")
    var fa = localStorage.getItem("lipid1")

    //get from (Total.js) for calculation (energy, LL, UL)
    var dextrose = localStorage.getItem("dextroseCC") //dextroseCC
    var protein = localStorage.getItem("proteinCC") // proteinCC
    var fat =localStorage.getItem("fatCC") //fatCC
    



    var energy = ((+dextrose + +protein + +fat)).toFixed(0)
    var energy1 = ((+dextrose +  +protein + +fat) * 4.184).toFixed(0)

    const home = () => {
        history.push("/")
    }


    var LL = localStorage.getItem("LL")
    var UL = localStorage.getItem("UL")

    //LL and UL percentages
    var LLP = ((energy / LL) * 100).toFixed(0)
    localStorage.setItem("percentage llp", LLP)
    var ULP = ((energy / UL) * 100).toFixed(0)
    localStorage.setItem("percentage ulp", ULP)


    //false ==> red => LLP
    const [isBackgroundRed, setisBackgroundRed] = useState(false);
    //false  ==> green => ULP
    const [isBackgroundGreen, setisBackgroundGreen] = useState(false);

     //ll
     const [green, setGreen] = useState(false);
     const [orange, setOrange] = useState(false);
     const [red, setRed] = useState(false);
     //ul
     const [greenUL, setGreenUL] = useState(false);
     const [orangeUL, setOrangeUL] = useState(false);
     const [redUL, setRedUL] = useState(false);


     //<50 RED
        //50-79 ORANGE (x)
        //80-100 GREEN

     //for LLP

     const handleLLP = () => {


        if ( LLP >= 80) {
            setisBackgroundRed(true)
            setGreen(true)
            setOrange(false)
            setRed(false)
        }  

  
        else if (LLP < 50 ) {
            setisBackgroundRed(false)
            setGreen(false)
            setOrange(false)
            setRed(true)
        }
  
        else { //in between 50-79

            setGreen(false)
            setOrange(true)
            setRed(false)

        }
  
      }


      //for ULP
      const handleULP = () => {

        if (ULP >= 80)  {
            setisBackgroundGreen(false);
            setGreenUL(true)
            setOrangeUL(false)
            setRedUL(false)
        }

        else if (ULP < 50 ) {
            setisBackgroundGreen(true)
            setGreenUL(false)
            setOrangeUL(false)
            setRedUL(true)
        }

        else {
            setGreenUL(false)
            setOrangeUL(true)
            setRedUL(false)
        }

    }
  

    useEffect(() => {
        handleLLP()
        handleULP()
        const interval = setInterval(() => {
            handleLLP()
            handleULP()
          }, 10000); //1 seconds
          return () => clearInterval(interval);
    }, [])



    return (
        
        <div className="row">
        <div className="col-md-12">
        <div className="total__page">
        <Header/>
        <div className = "total__content">
            <div className = "total__contentHeader">
                <strong>TPN Regimen</strong>
            </div>
            <Table  striped  hover size="sm" responsive="sm" className = "table__regimen" > 
                <thead>
                    <tr>
                        <th>
                            Weight( kg)
                        </th>
                        <th>
                            <strong>{weight}</strong>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>DEXTROSE (%)</td>
                        <td><strong>{dext}</strong> </td>
                    </tr>
                    <tr>
                        <td>PROTEIN (g/kg)</td>
                        <td><strong>{prot == "NaN" ? "x" : prot}</strong></td>
                    </tr>
                    <tr>
                        <td>FAT (g/kg)</td>
                        <td><strong>{fa == "NaN" ? "x" : fa}</strong></td>
                    </tr>
                </tbody>
            </Table>


            <div className = "total__contentHeader">
            <p><strong>Estimated Energy Intake</strong></p>
            </div>
            <Grid container spacing = {5}> 
            <Grid item xs={3}>
                {/*SPACE */}
                </Grid>
            <Grid item xs={3}>
                <span className = "kcals__kg__dayy">
                    kcals/kg/day
                </span>
                </Grid>
                <Grid item xs={3}>
                <span className = "kl__kg__dayy">
                    kJ/kg/day
                </span>
                </Grid>
            </Grid>

            <Grid container spacing = {5}>
                <Grid item xs={3}>
                    <strong>Energy</strong> 
                </Grid>
                <Grid item xs={3}>
                    <button className = "energy__button11">{energy == "NaN" ? "x": energy}</button>
                </Grid>
                <Grid item xs={3}>
                  <button className ="energy__button12">{energy1 == "NaN" ? "x" : energy1}</button> 
                </Grid>
            </Grid>

            <div className = "total__contentHeader1">
            <p><strong>Percentage of Estimated Energy Requirements Achieved</strong></p>
            </div>

            
            <div className = "slanted__pushed">

            <Grid container spacing = {2}>
                <Grid item xs={6}>
                <span className = "lower__limit">  
                    LOWER LIMIT
                </span>
                </Grid>
                <Grid item xs={6}>
                <span className = "upper__limit">
                    UPPER LIMIT               
                </span>
                </Grid>
            </Grid>

            <Grid container spacing = {2}>
                <Grid item xs={6}>
                <div className ="percentage__limit">
                    <span onChange =  {handleLLP} value = {LLP}> {green && <GreenLL/>} </span>
                    <span onChange =  {handleLLP} value = {LLP}> {orange && <OrangeLL/>} </span>
                    <span onChange =  {handleLLP} value = {LLP}> {red && <RedLL/>} </span>
                </div>
                </Grid>
                <Grid item xs={6}>
                <div className ="percentage__limit1">
                    <span onChange =  {handleULP} value = {ULP}> {greenUL && <GreenUL/>} </span>
                    <span onChange =  {handleULP} value = {ULP}> {orangeUL && <OrangeUL/>} </span>
                    <span onChange =  {handleULP} value = {ULP}> {redUL && <RedUL/>} </span>
                </div>
                </Grid>
            </Grid>    

            <Grid container spacing = {4}>                   
            <button  className = "goto__homee" onClick = {home}>
                    <Icon icon={homeIcon} />    Homepage
            </button>
            </Grid>

        </div>

         </div>
        </div>
        </div>
        </div>
    )
}

export default CalculateTotal
